"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _TransferRequest = require("./TransferRequest");
Object.keys(_TransferRequest).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TransferRequest[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _TransferRequest[key];
    }
  });
});